"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooterButtonsWidget = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var SharedWidgets_1 = require("../../SharedWidgets");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var getStyles = function () {
    return {
        ButtonsContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-end'
        },
        FooterButton: {
            paddingLeft: TabStyles_1.TabStyles.Spacing.MediumSpace
        }
    };
};
var getFooterButtons = function (props) {
    return (props.buttons.map(function (buttonProps, idx) {
        return (React.createElement("div", { style: Declarative_1.conditional(idx !== 0, getStyles().FooterButton), key: idx },
            React.createElement(SharedWidgets_1.ButtonWidget, tslib_1.__assign({}, buttonProps))));
    }));
};
/**
 * These buttons shall be right-justified, vertically centered, and appropriately spaced.
 */
exports.DialogFooterButtonsWidget = function (props) {
    var containerProps = {
        'data-tb-test-id': Declarative_1.makeTestId(props.testId, 'Confirm-Cancel-Footer'),
        style: getStyles().ButtonsContainer
    };
    return (React.createElement("div", tslib_1.__assign({}, containerProps), getFooterButtons(props)));
};
//# sourceMappingURL=DialogFooterButtonsWidget.js.map